import React from "react";
import { TimelineData } from "src/shared/types/src";
import { ACTIVITY_DETAIL_TYPE, MEDICINE_FORM_STATUS } from "src/shared/config/src";
import AccidentMedicineReportCardInternalDetails from "src/app/components/commonComponents/AccidentMedicineReportCardInternalDetails";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/app/navigation/routes";
import { navigateToDownloadAppScreen } from "src/app/utilities/helpers";

const MedicineFormCard = ({ timelineItem }: { timelineItem: TimelineData }) => {

    const navigate = useNavigate();

    return (
        <BaseCard
            onPressFunc={() => {
                if (timelineItem?.status === MEDICINE_FORM_STATUS.REJECTED) {
                    navigateToDownloadAppScreen()
                } else {
                    navigate(AppRoutes.MEDICINE_FORM_DETAILS(timelineItem?.id))
                };

            }}
            clickable={true}
            customBaseCardStyle="mg-t-15"
        >
            <AccidentMedicineReportCardInternalDetails
                type={ACTIVITY_DETAIL_TYPE.MEDICINE}
                content={timelineItem?.content}
                timestamp={timelineItem?.timestamp}
                status={timelineItem?.status}
                notes={timelineItem?.details?.notes}
            />
        </BaseCard>
    )
}

export default MedicineFormCard;